import { render } from "./ModalLink.vue?vue&type=template&id=fa3ff926"
import script from "./ModalLink.vue?vue&type=script&lang=js"
export * from "./ModalLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__